<template>
      <div class="tabs_content">
        <section>
          <div class="left">
            <h2 v-translate>Základní nastavení</h2>
          </div>
          <div class="right">
            <div class="field_left">
              <select-box
                  id="dashboard_animations_selectbox"
                  :options="dashboardAnimationsOptions"
                  v-model="dashboardAnimations"
                  :disabled="!isEditable"
                  @input="_dashboardAnimationOptionChanged">

                <translate class="translate">Nastavení animací dashboardu</translate>
              </select-box>
              <div class="field">
                <input :disabled="!isEditable || !!!entity.device.dashboard_animations"
                       @change="_onDefaultDashboardAnimationChanged" type="checkbox" id="dashboard_animations"
                       name="dashboard_animations"
                       :checked="entity.device.dashboard_animations ? entity.device.dashboard_animations.editable : false">
                <label for="dashboard_animations" v-translate>Povolit změnu nastavení animací dashboardu</label>
              </div>
            </div>
          </div>
        </section>

        <SettingsTable
            :is-editable="isEditable"
            :title="$gettext('Zpoždění číselné volby (s)')"
            :value-label="$gettext('Hodnota (s)')"
            :settingsObject="this.entity.device['numeric_keys_latency']"
            sorting-key="keys_latency"
            @addValue="_onAddValueToKeysLatency"
            @editableChanged="_onEditableKeysLatencyChanged"
            @defaultValueChanged="_onDefaultKeysLatencyChanged"
            @removeValueByIndex="_onRemoveValueByIndexFromKeysLatency"
            @valuesSorted="_onValuesKeysLatencySorted"
        />

        <SettingsTable
            :is-editable="isEditable"
            :title="$gettext('Zpoždění přepnutí kanálu (s)')"
            :value-label="$gettext('Hodnota (s)')"
            :settingsObject="this.entity.device['channel_switch_timeout']"
            sorting-key="channel_switch_timeout"
            @addValue="_onAddValueToChannelSwitchTimeout"
            @editableChanged="_onEditableChannelSwitchTimeoutChanged"
            @defaultValueChanged="_onDefaultChannelSwitchTimeoutChanged"
            @removeValueByIndex="_onRemoveValueByIndexFromChannelSwitchTimeout"
            @valuesSorted="_onValuesChannelSwitchTimeoutSorted"
        />

        <SettingsTable
            :is-editable="isEditable"
            :title="$gettext('Automatické uspání (s)')"
            :value-label="$gettext('Hodnota (s)')"
            :settingsObject="this.entity.device['automatic_standby_after']"
            sorting-key="automatic_standby"
            @addValue="_onAddValueToAutomaticStandby"
            @editableChanged="_onEditableAutomaticStandbyChanged"
            @defaultValueChanged="_onDefaultAutomaticStandbyChanged"
            @removeValueByIndex="_onRemoveValueByIndexFromAutomaticStandby"
            @valuesSorted="_onValuesAutomaticStandbySorted"
        />

        <SettingsTable
            :is-editable="isEditable"
            :title="$gettext('Automatické zamykání (s)')"
            :value-label="$gettext('Hodnota (s)')"
            :settingsObject="this.entity.device['automatic_device_lock_after']"
            sorting-key="automatic_lock"
            @addValue="_onAddValueToAutomaticLock"
            @editableChanged="_onEditableAutomaticLockChanged"
            @defaultValueChanged="_onDefaultAutomaticLockChanged"
            @removeValueByIndex="_onRemoveValueByIndexFromAutomaticLock"
            @valuesSorted="_onValuesAutomaticLockSorted"
        />

        <SettingsTable
            :is-editable="isEditable"
            :title="$gettext('Kvalita grafiky')"
            :value-label="$gettext('Kvalita')"
            :settingsObject="this.entity.device['graphics_quality']"
            :fixed-values="availableValues.graphics_quality_values"
            sorting-key="graphics_quality"
            @addValue="_onAddValueToGraphicsQuality"
            @editableChanged="_onEditableGraphicsQualityChanged"
            @defaultValueChanged="_onDefaultGraphicsQualityChanged"
            @removeValueByIndex="_onRemoveValueByIndexFromGraphicsQuality"
            @valuesSorted="_onValuesGraphicsQualitySorted"
            :nameTransformFunction="_getQualityName"
        />

      <ImageSizeSettingsTable
          :is-editable="isEditable"
          :title="$gettext('Velikost obrázku - Poster')"
          :value-label="$gettext('Přidat volbu')"
          :settingsObject="entity.device['poster_image_size']"
          sorting-key="poster_image_size"
          :fixed-values="availableValues.image_size_types"
          @addValue="_onAddValueToPosterImageSize"
          @editableChanged="_onEditablePosterImageSizeChanged"
          @defaultValueChanged="_onDefaultPosterImageSizeChanged"
          @removeValueByIndex="_onRemoveValueByIndexFromPosterImageSize"
          @valuesSorted="_onValuesPosterImageSizeSorted"
          :nameTransformFunction="_getImageSizeTypesName"
          :typeOptions="availableValues.poster_image_size_values"
      />

      <ImageSizeSettingsTable
          :is-editable="isEditable"
          :title="$gettext('Velikost obrázku - Photo')"
          :value-label="$gettext('Přidat volbu')"
          :settingsObject="entity.device['photo_image_size']"
          sorting-key="photo_image_size"
          :fixed-values="availableValues.image_size_types"
          @addValue="_onAddValueToPhotoImageSize"
          @editableChanged="_onEditablePhotoImageSizeChanged"
          @defaultValueChanged="_onDefaultPhotoImageSizeChanged"
          @removeValueByIndex="_onRemoveValueByIndexFromPhotoImageSize"
          @valuesSorted="_onValuesPhotoImageSizeSorted"
          :nameTransformFunction="_getImageSizeTypesName"
          :typeOptions="availableValues.photo_image_size_values"
      />

    </div>
</template>

<script>
import formFilterData from "@/components/mixins/form-filter-data"
import SettingsTable from "../../../common/SettingsTable.vue";
import settingsMixins from "../mixins/settings";
import ImageSizeSettingsTable from "./ImageSizeSettingsTable.vue";

export default {
    name: "Device",
    components: {SettingsTable, ImageSizeSettingsTable},
    mixins: [formFilterData, settingsMixins],
    props: {
        entity: Object,
        isEditable: Boolean,
        availableValues: Object
    },
    data() {
      return {
        dashboardAnimations: this.entity.device.dashboard_animations ? this.entity.device.dashboard_animations.default : null,
      }
    },
    computed: {
      dashboardAnimationsOptions() {
        return [{
          id: null,
          text: this.$gettext('Neuplatňuje se')
        },
          {
            id: false,
            text: this.$gettext('Zakázáno')
          }, {
            id: true,
            text: this.$gettext('Povoleno')
          }];
      },
    },
    methods: {
        _dashboardAnimationOptionChanged(value) {
          if (value === null) {
            this._deleteSubkey('device', 'dashboard_animations');
          } else {
            this._defaultValueChanged('device', 'dashboard_animations', value === 'true', [true, false]);
          }
        },
        _onDefaultDashboardAnimationChanged(event) {
          this._editableChanged('device', 'dashboard_animations', event.target.checked, [true, false]);
        },
        _onAddValueToKeysLatency(value) {
            value = parseFloat(value);
            if (!isNaN(value)) {
                this._addValue('device', 'numeric_keys_latency', value);
            }
        },
        _onEditableKeysLatencyChanged(value) {
            this._editableChanged('device', 'numeric_keys_latency', value === 'true');
        },
        _onDefaultKeysLatencyChanged(value) {
            this._defaultValueChanged('device', 'numeric_keys_latency', parseFloat(value));
        },
        _onRemoveValueByIndexFromKeysLatency(index) {
            this._removeValueByIndex('device', 'numeric_keys_latency', index);
        },
        _onValuesKeysLatencySorted(values) {
            this._replaceValues('device', 'numeric_keys_latency', values.map(Number));
        },
        _onAddValueToChannelSwitchTimeout(value) {
            value = parseFloat(value);
            if (!isNaN(value)) {
                this._addValue('device', 'channel_switch_timeout', value);
            }
        },
        _onEditableChannelSwitchTimeoutChanged(value) {
            this._editableChanged('device', 'channel_switch_timeout', value === 'true');
        },
        _onDefaultChannelSwitchTimeoutChanged(value) {
            this._defaultValueChanged('device', 'channel_switch_timeout', parseFloat(value));
        },
        _onRemoveValueByIndexFromChannelSwitchTimeout(index) {
            this._removeValueByIndex('device', 'channel_switch_timeout', index);
        },
        _onValuesChannelSwitchTimeoutSorted(values) {
            this._replaceValues('device', 'channel_switch_timeout', values.map(Number));
        },
        _onAddValueToAutomaticStandby(value) {
            this._addValue('device', 'automatic_standby_after', ~~value);
        },
        _onEditableAutomaticStandbyChanged(value) {
            this._editableChanged('device', 'automatic_standby_after', value === 'true');
        },
        _onDefaultAutomaticStandbyChanged(value) {
            this._defaultValueChanged('device', 'automatic_standby_after', ~~value);
        },
        _onRemoveValueByIndexFromAutomaticStandby(index) {
            this._removeValueByIndex('device', 'automatic_standby_after', index);
        },
        _onValuesAutomaticStandbySorted(values) {
            this._replaceValues('device', 'automatic_standby_after', values.map(Number));
        },
        _onAddValueToAutomaticLock(value) {
            this._addValue('device', 'automatic_device_lock_after', ~~value);
        },
        _onEditableAutomaticLockChanged(value) {
            this._editableChanged('device', 'automatic_device_lock_after', value === 'true');
        },
        _onDefaultAutomaticLockChanged(value) {
            this._defaultValueChanged('device', 'automatic_device_lock_after', ~~value);
        },
        _onRemoveValueByIndexFromAutomaticLock(index) {
            this._removeValueByIndex('device', 'automatic_device_lock_after', index);
        },
        _onValuesAutomaticLockSorted(values) {
            this._replaceValues('device', 'automatic_device_lock_after', values.map(Number));
        },
        _onAddValueToGraphicsQuality(value) {
            this._addValue('device', 'graphics_quality', value);
        },
        _onEditableGraphicsQualityChanged(value) {
            this._editableChanged('device', 'graphics_quality', value === 'true');
        },
        _onDefaultGraphicsQualityChanged(value) {
            this._defaultValueChanged('device', 'graphics_quality', value);
        },
        _onRemoveValueByIndexFromGraphicsQuality(index) {
            this._removeValueByIndex('device', 'graphics_quality', index);
        },
        _onValuesGraphicsQualitySorted(values) {
            this._replaceValues('device', 'graphics_quality', values);
        },
        _getQualityName(value) {
            switch (value) {
                case 'classic':
                    return this.$gettext('Vysoký výkon');
                case 'medium_device':
                    return this.$gettext('Střední výkon');
                case 'poor_device':
                    return this.$gettext('Nízký výkon');
                default:
                    return value;
            }
        },
        _onAddValueToPosterImageSize(value) {
          this._addValue('device', 'poster_image_size', value);
        },
        _onEditablePosterImageSizeChanged(value) {
          this._editableChanged('device', 'poster_image_size', value === 'true');
        },
        _onDefaultPosterImageSizeChanged(value) {
          this._defaultValueChanged('device', 'poster_image_size', value);
        },
        _onRemoveValueByIndexFromPosterImageSize(index) {
          this._removeValueByIndex('device', 'poster_image_size', index);
        },
        _onValuesPosterImageSizeSorted(values) {
          this._replaceValues('device', 'poster_image_size', values);
        },
        _onAddValueToPhotoImageSize(value) {
          this._addValue('device', 'photo_image_size', value);
        },
        _onEditablePhotoImageSizeChanged(value) {
          this._editableChanged('device', 'poster_image_size', value === 'true');
        },
        _onDefaultPhotoImageSizeChanged(value) {
          this._defaultValueChanged('device', 'photo_image_size', value);
        },
        _onRemoveValueByIndexFromPhotoImageSize(index) {
          this._removeValueByIndex('device', 'photo_image_size', index);
        },
        _onValuesPhotoImageSizeSorted(values) {
          this._replaceValues('device', 'photo_image_size', values);
        },
        _getImageSizeTypesName(value) {
          switch (value) {
            case 'low':
              return this.$gettext('Nízká kvalita');
            case 'mid':
              return this.$gettext('Střední kvalita');
            case 'high':
              return this.$gettext('Vysoká kvalita');
            case 'original':
              return this.$gettext('Originál');
            default:
              return value;
          }
        },
    }
}
</script>



// WEBPACK FOOTER //
// src/components/views/deviceConfigs/forms/Device.vue